import type { NextPage } from "next";

interface Props {
  height?: string;
  width?: string;
  color?: string;
  key?: string;
}

const KlubBackgroundHalfCircleVector: NextPage<Props> = ({
  width = "515",
  height = "179",
  color = "#52A4FF",
  key = "diving",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 515 179"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M528 259L-8.1392e-06 259C-3.64366e-06 116.374 118.23 0.775377 264 0.775382C409.77 0.775387 528 116.374 528 259Z"
        fill={color}
      />
    </svg>
  );
};

export default KlubBackgroundHalfCircleVector;
